require('bxslider/dist/jquery.bxslider.min');
